import { CoreModule } from './../core/core.module';
import { NgModule } from '@angular/core';
import { CovanceAgGridModule } from '../covance-ag-grid/covance-ag-grid.module';
import { CovanceFilterModule } from '../covance-filter/covance-filter.module';
import { GroupingModule } from '../grouping-selector/grouping.module';
import { LegendModule } from '../legend/legend.module';
import { SharedModule } from './../shared/shared.module';
import { CategoriesStorage } from './categories-storage';
import { DocumentDownloader } from '../shared/document-downloader/document-downloader';
import { DocumentsGridComponent } from './documents-grid.component';
import { LanguageLinkAgRendererComponent } from './language-link/language-link-ag-renderer.component';
import { PlayVideoDialogComponent } from './language-link/play-video-dialog.component';
import { PreviewDialogComponent } from './language-link/preview-dialog.component';
import { ReportsGridComponent } from './reports-grid.component';
import { UserModule } from '../user';
import { ReportDownloader } from './report-downloader';
import { FilteredGridComponent } from './filtered-grid.component';
import { ELearningOpener } from '../e-learning/e-learning-opener';

@NgModule({
    imports: [
        SharedModule,
        CoreModule,
        UserModule,
        CovanceAgGridModule,
        GroupingModule,
        CovanceFilterModule,
        LegendModule,
    ],
    declarations: [
        LanguageLinkAgRendererComponent,
        PlayVideoDialogComponent,
        PreviewDialogComponent,
        ReportsGridComponent,
        DocumentsGridComponent,
        FilteredGridComponent
    ],
    entryComponents: [
        LanguageLinkAgRendererComponent,
        PlayVideoDialogComponent,
        PreviewDialogComponent,
    ],
    providers: [
        DocumentDownloader,
        ReportDownloader,
        CategoriesStorage,
        ELearningOpener,
    ],
    exports: [
        LanguageLinkAgRendererComponent,
        ReportsGridComponent,
        DocumentsGridComponent,
        SharedModule,
        CovanceAgGridModule,
        GroupingModule,
        CovanceFilterModule,
        LegendModule,
        FilteredGridComponent,
    ]
})
export class DocumentsModule { }
